module.exports = __webpack_public_path__ + "assets/manual_familyAccident-420bfabd84c2a1b822213cbba99fa3e0.pdf";